import createTheme from '@material-ui/core/styles/createTheme'

import customer from './customer'
import portalConfig from '../services/portalConfig'

let memo = { config: undefined, portal: null, mui: null }

const compute = () => {
  const config = portalConfig.config()

  if (memo.config !== config) {
    const portal = customer.resolveTheme(config ? config.theme || {} : null)

    const base = createTheme({ palette: portal.palette })
    const mui = createTheme({
      palette: portal.palette,
      overrides: {
        MuiInputBase: {
          input: {
            '&.Mui-disabled': {
              WebkitTextFillColor: base.palette.text.secondary,
              opacity: 1,
            },
          },
        },
      },
    })

    memo = { config, portal, mui }
  }

  return memo
}

const colors = {
  get theme() {
    return compute().mui
  },
  portalTheme: () => compute().portal,
}

export default colors
